import Lottie from 'lottie-react';

import lottieEmptyReport from '../jsons/provider-report-empty.json';

const LottieProviderReportEmpty = props => {
  return <Lottie animationData={lottieEmptyReport} loop={false} {...props} />;
};

export default LottieProviderReportEmpty;
